import React, { Component } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/esm/FormControl';
import "./Employees.css"

interface EmployeeFilterProps {
    input: string,
    placeholder: string,
    handleFilter: any,
    clearForm: any,
}

class EmployeeFilter extends Component<EmployeeFilterProps>{

    render() {

        return (
            <div className="EmployeeFilter" id="employee-filter-wrapper">
                <InputGroup className="mb-3">
                    <div className="EmployeeSearchClear">
                        {this.props.input.length > 0 && <InputGroup.Prepend>
                            <InputGroup.Text id="basic-addon1" onClick={this.props.clearForm}><span className="material-icons">close</span></InputGroup.Text>
                        </InputGroup.Prepend>}
                    </div>
                    <div className="EmployeeSearchSearch">
                        {this.props.input.length === 0 && <InputGroup.Prepend>
                            <InputGroup.Text id="basic-addon1"><span className="material-icons">search</span>
                            </InputGroup.Text>
                        </InputGroup.Prepend>}
                    </div>
                    <FormControl
                        placeholder={this.props.placeholder}
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        onChange={this.props.handleFilter}
                        value={this.props.input}
                    />
                </InputGroup>
            </div>
        )
    }
}

export default EmployeeFilter